import React from 'react';

function Classes() {
  return (
    <div className="classes" style={{ paddingTop: '20px' }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="titlepage text-center">
              <h2>Empower Your Mind and Body</h2>
              <span>Discover the right practice for your mind and body</span>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-10">
            <p className="text-center">
              At Nachiketa Yoga in <strong>Bopal, Ahmedabad</strong>, we offer a variety of yoga classes designed to meet the needs of practitioners at all levels. 
              From gentle beginner sessions to challenging advanced practices, our experienced instructors guide you through 
              mindful movements, breathing techniques, and meditation.
            </p>
          </div>
        </div>
        <div className="row justify-content-center mt-4">
          <div className="col-md-4 col-sm-6 mb-4">
            <div className="yoga_box text-center">
              <div style={{ fontSize: '48px', color: '#f4a111', marginBottom: '15px' }}>
                <i className="fa fa-leaf"></i>
              </div>
              <h3>Beginner Yoga</h3>
              <p>Perfect for newcomers focusing on basic poses and proper alignment at our Bopal nachiketa yoga classes.</p>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 mb-4">
            <div className="yoga_box text-center">
              <div style={{ fontSize: '48px', color: '#f4a111', marginBottom: '15px' }}>
                <i className="fa fa-balance-scale"></i>
              </div>
              <h3>Vinyasa Flow</h3>
              <p>Dynamic sequences linking breath with movement for strength and flexibility at our place.</p>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 mb-4">
            <div className="yoga_box text-center">
              <div style={{ fontSize: '48px', color: '#f4a111', marginBottom: '15px' }}>
                <i className="fa fa-heart"></i>
              </div>
              <h3>Gentle Yoga</h3>
              <p>Slow-paced practice focused on relaxation and stress reduction at our Bopal yoga center.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Classes;
